/**
 * Created by vladislav on 29.10.2021
 */

const SceneDebugger = function () {
    this.isTextsVisible = true;
    this.matchedNodes = [];
    this.hiddenNodes = [];

    cleverapps.inputDispatcher.on("pointerdown", (touch) => {
        if (this.onTouchBegan(touch)) {
            touch.stopPropagation();
        }
    });

    cleverapps.inputDispatcher.on("keyreleased", (key) => {
        if (key === InputDispatcher.KEY.Delete || key === InputDispatcher.KEY.backspace) {
            this.removeSelectedNode();
        }
    });
};

SceneDebugger.prototype.toggleTexts = function () {
    cleverapps.UI.findNodes(cc.LabelTTF).forEach((label) => {
        label.visible = !this.isTextsVisible;
    });
    this.isTextsVisible = !this.isTextsVisible;
};

SceneDebugger.prototype.removeSelectedNode = function () {
    if (this.selectedNode && this.selectedNode.onDeletePressed) {
        this.selectedNode.onDeletePressed();
    } else if (this.selectedNode && this.selectedNode.removeFromParent) {
        this.selectedNode.removeFromParent();
        this.selectedNode = undefined;
    }
};

SceneDebugger.prototype.toggleMatchedNodes = function () {
    let visible;

    if (this.matchedNodes.length) {
        visible = !this.matchedNodes[0].visible;
        this.matchedNodes.forEach(function (node) {
            if (this.hiddenNodes[node.__instanceId]) {
                delete this.hiddenNodes[node.__instanceId];
            }
            node.setVisible(visible);
            if (!visible) {
                this.hiddenNodes[node.__instanceId] = node;
            }
        }, this);
    } else if (this.selectedNode) {
        visible = !this.selectedNode.visible;
        if (visible) {
            delete this.hiddenNodes[this.selectedNode.__instanceId];
        } else {
            this.hiddenNodes[this.selectedNode.__instanceId] = this.selectedNode;
        }
        this.selectedNode.setVisible(visible);
    } else if (Object.keys(this.hiddenNodes).length) {
        Object.keys(this.hiddenNodes).forEach(function (instanceId) {
            this.hiddenNodes[instanceId].setVisible(true);
        }, this);
        this.hiddenNodes = {};
    }
};

SceneDebugger.prototype.processTouch = function (touch, node, stop) {
    const processTouch = (touch, node, stop) => {
        let matchedNode;

        if (!node || !node.visible) {
            return matchedNode;
        }
        if (typeof EditorScene !== "undefined" && node instanceof EditorScene) {
            return matchedNode;
        }
        if (node instanceof cleverapps.OutlineSprite) {
            return matchedNode;
        }

        const excluded = this.excluded.some((nodeClass) => node instanceof nodeClass) || node._hideInSceneDebugger || node._isPrefab;

        if (node.hasTouch(touch) && !node._debugExclude && !excluded) {
            matchedNode = node;
        }

        if (stop) {
            return matchedNode;
        }

        const children = node.getChildren();
        let i = 0, child;

        for (; i < children.length; i++) {
            child = children[i];
            if (child && child.getLocalZOrder() < 0) {
                matchedNode = processTouch(touch, child) || matchedNode;
            } else {
                break;
            }
        }

        for (; i < children.length; i++) {
            child = children[i];

            if (child) {
                matchedNode = processTouch(touch, child) || matchedNode;
            }
        }

        return matchedNode;
    };

    let selected = processTouch(touch, node, stop);
    if (selected) {
        const preferred = [cleverapps.UI.LabelTTF, cleverapps.UI.ImageFont, cc.Sprite, cleverapps.Spine];

        if (selected.parent && selected.parent.outlineSprite && selected.parent.outlineSprite === selected) {
            selected = selected.parent;
        }

        if (selected.parent && selected.parent._slotName && !preferred.some((nodeClass) => (selected instanceof nodeClass))) {
            selected = selected.parent;
        }
        return selected;
    }
};

SceneDebugger.prototype.onTouchBegan = function (touch) {
    const nodesToSkip = [];
    if (this.matchedNode && this.matchedNode.debugButtons) {
        nodesToSkip.push(this.matchedNode.debugButtons);
    }
    if (this.prefabMatchedNode && this.prefabMatchedNode.prefabButton) {
        nodesToSkip.push(this.prefabMatchedNode.prefabButton);
    }
    const scene = cleverapps.Scenes.GetRunningScene();
    if (scene.toolMenu) {
        nodesToSkip.push(scene.toolMenu, scene.toolMenu.opener);
    }
    let skip = false;
    nodesToSkip.forEach((node) => {
        const location = node.convertTouchToNodeSpace(touch);
        if (cc.rectContainsPoint(cc.rect(0, 0, node.width, node.height), location)) {
            skip = true;
        }
    });

    if (skip) {
        return;
    }

    if (this.matchedNode && this.matchedNode.debugButtons) {
        const button = this.matchedNode.debugButtons;
        const location = button.convertTouchToNodeSpace(touch);
        if (cc.rectContainsPoint(cc.rect(0, 0, button.width, button.height), location)) {
            return;
        }
    }

    this.excluded = [cleverapps.UI.ScrollView, cleverapps.UI.ScrollBarContainer];
    if (typeof CenterHint !== "undefined") {
        this.excluded.push(CenterHint);
    }
    if (typeof KeypadView !== "undefined") {
        this.excluded.push(KeypadView);
    }
    if (typeof MergeTutorialView !== "undefined") {
        this.excluded.push(MergeTutorialView);
    }
    if (typeof CenterHintView !== "undefined") {
        this.excluded.push(CenterHintView);
    }
    if (typeof ExclamationView !== "undefined") {
        this.excluded.push(ExclamationView);
    }
    if (typeof AdsGame !== "undefined") {
        this.excluded.push(AdsGame);
    }

    if (typeof CleverappsWindow !== "undefined") {
        this.excluded.push(CleverappsWindow);
    }

    if (typeof ShadowLayer !== "undefined") {
        this.excluded.push(ShadowLayer);
    }

    this.excluded.push(sp.SkeletonAnimation);

    if (cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.ctrl)) {
        const node = this.processTouch(touch, cleverapps.Scenes.GetRunningScene());
        if (node) {
            this.selectNode(node);
            return true;
        }
    }

    if (this.matchedNode && !this.matchedOptions.keepOnTouch) {
        const captureTouch = !this.matchedNode.skipCapture;
        this.unselectNodes();
        return captureTouch;
    }

    return false;
};

SceneDebugger.prototype.selectNode = function (node, options) {
    options = options || {};

    this.unselectNodes();

    if (node) {
        this.matchedNode = node;
        this.matchedOptions = options;
        this.selectedNode = node;

        const prefabSourceNode = cc.Base.GetHierarchy(this.matchedNode).find((node) => node._prefabSource && node.debugId !== "Scene");
        if (prefabSourceNode && prefabSourceNode !== this.matchedNode) {
            this.prefabMatchedNode = prefabSourceNode;
            this.prefabMatchedNode.debugPrefab();
        }

        this.matchedNode.debugParents();
        this.matchedNode.debugBorder({ showPosition: true, showAttributes: true });
        this.matchedNodes.push(this.matchedNode);

        if (this.matchedNode.onSceneSelected) {
            this.matchedNode.onSceneSelected(options);
        }

        this.matchedNode.addCleaner(this.unselectNode.bind(this, this.matchedNode, true));
    }
};

SceneDebugger.prototype.unselectNode = function (node, silent) {
    if (node) {
        node.cleanupBorder();

        if (node.onSceneUnselected) {
            node.onSceneUnselected(silent);
        }
    }
};

SceneDebugger.prototype.unselectNodes = function () {
    if (this.matchedNode) {
        this.unselectNode(this.matchedNode);
        this.matchedNode = undefined;
    }

    if (this.prefabMatchedNode) {
        this.unselectNode(this.prefabMatchedNode);
        this.prefabMatchedNode = undefined;
    }

    if (this.matchedNodes.length) {
        this.matchedNodes.forEach((node) => {
            this.unselectNode(node);
        });
        this.matchedNodes = [];
    }
};

SceneDebugger.prototype.isSelected = function (node) {
    return this.matchedNode && this.matchedNode === node;
};

SceneDebugger.prototype.createSpine = function (json) {
    const scene = cleverapps.Scenes.GetRunningScene();

    const spine = new cleverapps.Spine(json);
    spine.setAlignment(scene.width / 2, scene.height / 2);
    scene.addChild(spine);

    spine.setVisible(true);
    spine.debugBorder();

    console.log("skins:", Object.keys(spine.data.skins));
    console.log("animations:", Object.keys(spine.data.animations));
};
